import type { FilterValues } from "./preneed-filter";


export const headers = [
  {
    key: "bookingId",
    label: "Order ID",
  },
  {
    key: "customerName",
    label: "Customer Name",
  },
  {
    key: "bookingType",
    label: "Package Type ",
  },
  {
    key: "requestedDateAndTime",
    label: "Appointment Date & Time",
  },
  {
    key: "orderedDate",
    label: "Ordered Date",
  },
  {
    key: "status",
    label: "Status",
  },
];

export interface ServiceListSearchAndFiltersProps {
  onSearch: (searchText: string) => void;
  onFilterChange: (filters: FilterValues) => void;
  onResetFilters?: () => void;
  filterValues: FilterValues;
  placeholder?: string;
  appliedFiltersCount?: number;
  isFilterOpen?: boolean;
  setIsFilterOpen?: (isOpen: boolean) => void;
  searchRef?: React.RefObject<{ clear: () => void; searchValue?: string } | null>;
  isReset?: boolean;
  localSearchText?: string;
  createServiceHandler?: () => void;
  viewMode: "list" | "calendar";
  setViewMode: (mode: "list" | "calendar") => void;
}
